import React, { Suspense } from 'react';
import { Route, Switch, BrowserRouter as Router } from 'react-router-dom';
import Loading from './Components/App/Loading';

// Standard imports
import { Entry } from './views/Entry';
import { BusinessChallenge } from './views/BusinessChallenge';
import { Personas } from './views/Personas';
import { Milestone } from './views/Milestone';
import { MilestoneConnectors } from './views/MilestoneConnectors';
import { ProductsOverlay } from './views/ProductsOverlay';
import { NotFoundPage } from './views/NotFoundPage';

class Routes extends React.Component {
  render() {
    return (
      <Router basename="/">
        <Suspense fallback={<Loading />}>
          <Switch>
            <Route exact path="/" component={Entry} />
            <Route path="/BusinessChallenge" component={BusinessChallenge} />
            <Route path="/Personas" component={Personas} />
            <Route path="/Milestones" component={Milestone} />
            <Route
              path="/MilestoneConnectors"
              component={MilestoneConnectors}
            />
            <Route path="/ProductsOverlay" component={ProductsOverlay} />
            <Route component={NotFoundPage} />
          </Switch>
        </Suspense>
      </Router>
    );
  }
}

export default Routes;
